import React, { FC } from 'react';
import { Box, Container, Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import Image from 'next/image';
import { createStyles, makeStyles } from '@material-ui/styles';

interface FulfillmentBlockProps {
  image: string;
  title: string;
  description: string;
  isImageLeft?: boolean;
  subTitle?: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      marginTop: theme.spacing(9),
    },

    textBlock: {
      backgroundColor: '#F2F2F2',
      padding: theme.spacing(5, 3),
      height: 450,
      position: 'relative',
      maxWidth: 690,
      [theme.breakpoints.up('md')]: {
        height: 514,
      },
      [theme.breakpoints.up('lg')]: {
        padding: ({ isImageLeft }: Partial<FulfillmentBlockProps>) =>
          theme.spacing(9, isImageLeft ? 0 : 8, 9, isImageLeft ? 55 : 8),
        maxWidth: 930,
      },
      [theme.breakpoints.up('xl')]: {
        height: 514,
      },
    },
    title: {
      fontSize: 32,
      fontWeight: 700,
      [theme.breakpoints.up('sm')]: {
        fontSize: 48,
      },
    },
    text: {
      fontSize: 20,
      fontWeight: 500,
      color: '#4F5260',
      marginTop: theme.spacing(3),
      maxWidth: 552,
      [theme.breakpoints.up('sm')]: {
        fontSize: 24,
      },
    },
    image: {
      position: 'absolute',
    },
    subTitle: {
      fontSize: 24,
      fontWeight: 700,
    },
    imageWrapper: {
      position: 'relative',
      width: '100%',
      maxWidth: 690,
      height: 514,
      overflow: 'hidden',
    },
    imageInner: {
      objectFit: 'cover',
    },
  });
});

const FulfillmentBlock: FC<FulfillmentBlockProps> = ({ image, title, description, subTitle, isImageLeft = false }) => {
  const classes = useStyles({ isImageLeft });
  const isExtraLargeUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
  const isLargeUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  const isMediumUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  return (
    <Box mt={isMediumUp ? 34 : 15}>
      <Container fixed>
        {isLargeUp ? (
          <Grid container direction={isImageLeft ? 'row-reverse' : 'row'} style={{ position: 'relative' }}>
            <Grid className={classes.textBlock} item xs={9}>
              <Typography className={classes.title} color="primary">
                {title}
                <span className={classes.subTitle}>{subTitle}</span>
              </Typography>
              <Typography className={classes.text}>{description}</Typography>
            </Grid>
            <Box
              className={classes.imageWrapper}
              style={{
                maxWidth: isExtraLargeUp ? 690 : 600,
                position: 'absolute',
                right: isImageLeft ? 'auto' : 0,
                left: isImageLeft ? 0 : 'auto',
                top: -80,
              }}
            >
              <Image src={image} alt={title} fill className={classes.imageInner} sizes="(min-width: 1200px) 690px, 600px" />
            </Box>
          </Grid>
        ) : (
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center">
                <Image src={image} width={690} height={514} alt={title} />
              </Box>
            </Grid>
            <Grid item xs={12} className={classes.textBlock}>
              <Typography className={classes.title} color="primary">
                {title}
                <span className={classes.subTitle}>{subTitle}</span>
              </Typography>
              <Typography className={classes.text}>{description}</Typography>
            </Grid>
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default FulfillmentBlock;
